<template ref="mmm">
    <div class="body" ref="body" :data-r="rank">
        <upload-img :no-square="true"
                    field="avatar2"
                    upload-avatar-from-vuex
                    :user-id="user_id"
                    :account-id="aid"
                    img-format="png"
                    v-model="showUpload"
                    ki="0"
                    v-bind:lang-type="(locale||'en-US').toString().substring(0,2)"></upload-img>
        <mlm-popover trigger="click" :options="{placement: 'auto'}"
                     ref="mlm_popover">
            <div slot="reference" class="user-account-btn">
                <span id="dropdown_user">
                    <span id="id_b_p" class="icon-down" v-bind:style="{ color: colorName }" v-bind:class="loading? 'disabled' : ''" ref="ex1">
                        <font-awesome-icon icon="angle-down"></font-awesome-icon>
                    </span>
                </span>
                <div title="My Account" class="user-profile a-span"
                     aria-expanded="true">
                    <div class="display-inline" v-if="loading"
                         style="margin-right: 8px; float: left; width: 28px; height: 28px;"><span
                            style="margin-right: 0" class="loading"></span></div>
                    <img alt="Profile image" v-else class="mini-image"
                         v-bind:src="fields && fields['avatar_id'].value.raw
                            ? fields['avatar_id'].value.raw.imageUrl 
                            : (defaultAvatar == 'unisex' || (fields && !fields['gender'].value.raw) ? emptyPerson : (fields && fields['gender'].value.presentable.toString().toLowerCase() === 'female' ? emptyPersonFemale : emptyPersonMale))"
                         width="28" height="28">
                    <span id="name_user">
                        <span class="span-name" v-if="loading">{{ $t("message.loading") }}</span>
                        <span class="span-name" v-bind:style="{ color: colorName }" v-else>{{fields && fields['firstname'] != null ? (fields['firstname'].value.presentable + ' ' +fields['lastname'].value.presentable) : ''}}</span>
                    </span>

                </div>
            </div>
            <div slot="body">
                <div v-if="!loading">
                    <div class="box-sm">
                        <div class="login-box clearfix">
                            <div class="user-img user-account-btn">
                                <a href="#" title="" class="change-img open-payoutModal"
                                   data-target="#ava-update-form" role="button" @click="e=> {e.preventDefault(); this.showUpload = true;}">{{ $t("message.change") }}</a>
                                <img v-bind:src="fields && fields['avatar_id'].value.raw ? fields['avatar_id'].value.raw.imageUrl : (defaultAvatar == 'unisex' || (fields && !fields['gender'].value.raw) ? emptyPerson : (fields && fields['gender'].value.presentable.toString().toLowerCase() === 'female' ? emptyPersonFemale : emptyPersonMale))"
                                     alt="">
                            </div>
                            <div class="user-info">
                                  <span part="li-ap">
                                    {{fields && fields['firstname'] ? (fields['firstname'].value.presentable + ' ' +fields['lastname'].value.presentable) : ''}}<i>{{maskAccountId(aid.toString())}}</i>
                                  </span>
                                <a v-bind:href="'mailto:' + (fields ? fields['email'].value.presentablen : '')" part="li-ap"
                                   title="Send mail" class="email-text">{{ fields ? fields['email'].value.presentablen : '' }}</a>
                            </div>
                        </div>
                        <div class="divider"></div>
                        <ul class="reset-ul mrg5B">
                            <li v-for="item in bottomProps" v-bind:key="'bp_'+item" class="li-ap">
                                <template v-if="fields && fields[item]">
                                  <span v-if="item==='invite_code'" part="li-ap">
                                      {{fields[item].title + ': '}}<span ref="refC">{{getLink(fields[item].value.presentable)}}</span><font-awesome-icon icon="copy" class="mlm-copy" @click="clip('refC')"></font-awesome-icon></span>
                                  <span v-else-if="item==='parent_account_id' && fields[item] && fields[item].value.presentable" part="li-ap">
                                      {{fields[item].title + ': ' + maskAccountId(fields[item].value.presentable.toString())}}</span>
                                  <span v-else-if="isVisibleProp(item) && fields[item].isCopy" part="li-ap">
                                      {{fields[item].title + ': '}}<span :ref="'refC' + item">{{fields[item].value.presentable}}</span><font-awesome-icon icon="copy" class="mlm-copy" @click="clip('refC' + item)"></font-awesome-icon></span>
                                  <span v-else-if="isVisibleProp(item)" part="li-ap">
                                      {{fields[item].title + ': ' + fields[item].value.presentable }}</span>
                                </template>
                            </li>
                        </ul>
                        <div class="pad5A button-pane button-pane-alt text-center" part="bottomLogout">
                            <a href="#" role="button" @click="logout"
                               class="btn display-block font-normal btn-danger">{{ $t("message.logout") }}</a>
                        </div>
                    </div>
                </div>
            </div>


        </mlm-popover>
    </div>
</template>
<script>
    import mlmPopover from '../../nested_components/mlm_popover/Popover'
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
    import {faAngleDown, faCopy} from '@fortawesome/free-solid-svg-icons' //icon-cog, icon-envelope-o,icon-unlock-alt
    import uploadImg from '../../nested_components/upload_image/upload-img'
    import Layer0 from '../../extend_classes/Layer0'
    library.add(faAngleDown, faCopy);

    const i18n = new window.VueI18n({
        locale: 'en-US', // set locale
        fallbackLocale: 'en-US',

        messages: {
            "en-US": {
                "message": {
                    "logout": "Logout",
                    "change": "change",
                    "loading": "Loading"
                }
            }
        }

    });
    export default {
        name: 'user-pop',
        i18n: i18n,
        extends: Layer0,
        components: {
            FontAwesomeIcon,
            mlmPopover,
            uploadImg
        },
        data: function () {
            return {
                wMM: a => a,
                user_id: 0,
                showUpload: false,
                fields: null,
                sponsorId: null,
                sponsorPresentable: null,
                allProps: [],
                bottomProps: [],
                tp: ["firstname", "lastname", "avatar_id", "gender", "email"],
                loc_name: 'VUserPop',
                visibleProps: [],
                allTemplates : []
            }
        },
        props: {
            accountId: {
                required: false,
                type: Number
            },
            tree: {
                default: 0,
                required: false,
                type: Number
            },
            defaultAvatar: { // показать дефолтный независимо от указанного пола. Сменится только если загружен img аватар
                default: '',
                required: false,
                type: String
            },
            accountProperties: {
                default: '[]',
                required: false,
                type: String
            },
            colorName: {
                default: '',
                required: false,
                type: String
            }, 
            templates: { // возможность указаь, шаблоны для компонента, аналог в grav t. шаблоны
                default: '[]',
                required: false,
                type: String
            },
            templatesFrom: { // 1) templates-from="grav" - только из грава 2) templates-from="all" - из грава и из настроек компонента 
            //3) Если не указывать templates-from="..." тогда шаблоны берется только из настройки компонента templates="..." 
                default: '',
                required: false,
                type: String
            },
            ...Layer0.props
        },
        computed: {
            lastPageLowItems() {
                return (this.perPage * this.currentPage) < this.totalRows;
            }
        },
        methods: {
            clip(refId) {
                function selectText(element) {
                    let range;
                    if (document.selection) {
                        // IE
                        range = document.body.createTextRange();
                        range.moveToElementText(element);
                        range.select();
                    } else if (window.getSelection) {
                        range = document.createRange();
                        range.selectNode(element);
                        window.getSelection().removeAllRanges();
                        window.getSelection().addRange(range);
                    }
                }
                /* Get the text field */
                let copyText = this.$refs[refId][0];
                selectText(copyText);
                /* Copy the text inside the text field */
                document.execCommand("copy");
            },
            logout(e) {
                e.preventDefault();
                this.store.dispatch('logout')
            },
            getAp() {
                this.wMM = window.MLMSoftUICore.wearMaskMoney;
                let at;
                at = JSON.parse(this.accountProperties);
                if (!Array.isArray(at)) {
                    at = [];
                }
                
                if (at.length) {
                    this.allProps = at.map((p) => {
                        if (p.replace(/^.\./g,'') === 'referral_code') {
                            p = 'invite_code'
                        }
                        return p.replace(/^.\./g,'')
                    });

                    if (this.templatesFrom == 'grav') {
                        this.allTemplates = this.store.state.gravTemplates;
                    } else if (this.templatesFrom == 'all') {
                        this.allTemplates = JSON.parse(this.templates).concat(this.store.state.gravTemplates);
                    } else {
                        this.allTemplates = JSON.parse(this.templates);
                    }

                    if (!Array.isArray(this.allTemplates)) {
                        this.allTemplates = [];
                    } else {
                        this.allTemplates.forEach((t) => {
                            t = t.replace(/^.\./, '').replace(/=.*/, '')
                            let found = at.find((a) => a.replace(/^.\./g,'') === t)
                            if (!found) {
                                this.allProps.push(t)
                            }
                        });
                    }

                    this.visibleProps = this.allProps.map((p) => {
                        if (p.replace(/^.\./g,'') === 'referral_code') {
                            p = 'invite_code'
                        }
                        return p.replace(/^.\./g,'')
                    });

                }    
            },
            async getInfo() {
                try {
                    await this.store.dispatch('getLocalizationModule', {module: 'Api2Middleware', i18n, customLocalization: '/user/themes/monarch/images/localization_core/core.txt', UIProxyLoc: JSON.parse(JSON.stringify(i18n._vm.messages))});
                } catch (error) {
                    console.log('-------------------------------')
                    console.log('error', error)
                }

                this.loading = true;
                this.aid = this.accountId;
                if (!this.aid)
                    this.aid = await this.store.dispatch('getAccountId');
                if (!this.aid)
                    return false;
                try {
                  await this.store.dispatch('hasAccountPosition');
                } catch (e) {
                  console.log(e)
                }

                let propsQuery = ''
                let position   = null

                let at = JSON.parse(this.accountProperties);
                if (!Array.isArray(at)) {
                    at = [];
                }         
       
                at.forEach((value) => {
                    if (/m./.test(value)) {
                        propsQuery += `properties[]=${value.replace(/^.\./g,'')}&`
                    }
                })

                if (propsQuery) {
                    propsQuery = '&' + propsQuery.slice(0,-1)
                }

                await this.store.dispatch('requestApi3', {
                    path: `account/${this.aid}/position?treeId=${this.tree}${propsQuery}`,
                    method: 'get'
                }).then(response => {
                    position = response.data?.payload
                }).catch((e) => {
                    console.log(e)
                })

                const properties = new Set(this.allProps.concat(this.tp));
                this.bottomProps = this.allProps;
                this.allProps    = [...properties];

                this.buildFields(position, this.store.state.currentProfile);
                this.loading = false;
            },
            getLink(val){
                if (val) {
                    return 'https://' + window.location.host + '/?ref=' + val
                } else {
                    return ''
                }
            },
            isVisibleProp(propName) {
                return this.visibleProps.includes(propName)
            },
            deepFind(obj, path) {
                let current = obj, i;
                if(obj) {
                  if (path.length) {
                    const tmp = path.split('.');
                    for (i = 0; i < tmp.length; ++i) {
                      if (current[tmp[i]] == null) {
                        return undefined;
                      } else {
                        current = current[tmp[i]];
                      }
                    }
                  }
                  return current;
                } else {
                  return '';
                }

            },
            async setPropTemplates(position, profile, tempFields) {
                return this.store.dispatch('parseGravTemplates', {templates: this.allTemplates, position, profile}).then((newTempFields) => {

                    // set flag isCopy - means show clip button for property
                    newTempFields = newTempFields.map((t) => {
                        if (t[1].value.raw && /#isCopy#/.test(t[1].value.raw)) {
                            t[1].value.presentable = t[1].value.presentable.replace(/#isCopy#/, '');
                            t[1].isCopy            = true;
                        }
                        return t
                    })
                    // -------------

                    let newToTempFields = [];
                    tempFields          = tempFields.map((f) => {
                        newTempFields.forEach((t) => {
                            if (f[0] == t[0]) {
                                f = t
                            } else {
                                newToTempFields.push(t)
                            }
                        })

                        return f
                    })

                    newToTempFields.forEach((f) => {
                        tempFields.push(f)
                    })

                    return tempFields
                        
                }).catch((e) => {
                    console.log(e)
                });
            },
            
            localLocalization(tempFields) {
                this.store.dispatch('getPropsLocalization')

                return tempFields.map(item => {
                    let loc = i18n.t('properties.' + item[0])

                    if (loc && loc != 'properties.' + item[0]) {
                        item[1].title = loc
                    } else {
                        this.store.state.locProps.forEach((l) => {
                            if (item[0] === l.alias) {
                                if (/ru-RU/.test(window.location.href)) {
                                    item[1].title = l['ru-RU']
                                } else {
                                    item[1].title = l['en-US']
                                }
                            }
                        })
                    }
    
                    return item
                });
            },
            async buildFields(position, profile) {
                this.fields             = null;
                let tempFields          = [];
                let tempFieldsAddition  = [];
                this.sponsorId          = position[0].parentPosition ? position[0].parentPosition.account.id : null
                this.sponsorPresentable = position[0].parentPosition ? position[0].parentPosition.account?.idValue?.presentable : null
                let isGetSponsor        = false

                // if(r.get(this.aid + '.s.user_id')) {
                //     this.user_id = r.get(this.aid + '.s.user_id').obj_val.value;
                // }

                if (position[0].parentId) {
                    tempFields.push(['parent_account_id', { title: 'Parent Account Id', value: {presentable: position[0].parentId}, label: ''}]);
                }

                this.allProps.forEach((value) => {
                    let _value = value.replace(/^.\./g,'')

                    if (this.sponsorId && _value === 'sponsor_info') {
                        isGetSponsor = true;
                    }

                    position[0].properties.forEach((p) => {
                        if (_value == p.alias) {
                            tempFields.push([_value, p]);

                            if(_value !== 'avatar_id' && _value !== 'gender') {
                                p.alias = 'm.' + value
                                tempFieldsAddition.push(p);
                            }
                        }
                    })

                    profile.forEach((p) => {
                        if (_value == p.alias) {
                            tempFields.push([_value, p]);

                            if(_value !== 'avatar_id' && _value !== 'gender') {
                                p.alias = 'm.' + value
                                tempFieldsAddition.push(p);
                            }
                        }
                    })
                });

                if (isGetSponsor) {
                    await this.store.dispatch('requestApi3', {
                        path: `account/${this.sponsorId}/profile`,
                        method: 'get'
                    }).then((response) => {
                        let sponsorProfile = response.data.payload 

                        let fName = sponsorProfile.find((p) => p.alias === 'firstname');
                        let lName = sponsorProfile.find((p) => p.alias === 'lastname');
                        let name  = ''

                        if (fName) {
                            name = fName.value.presentable
                        }
                        if (lName) {
                            name = name + ' ' + lName.value.presentable
                        }
                    
                        tempFields.push(['sponsor_info', { title: 'My Sponsor', value: {presentable: name + ` (ID: ${this.sponsorPresentable || this.sponsorId})`}, label: ''}]);
                    }).catch((e) => {
                        console.log(e)
                    })
                }

                await this.setPropTemplates(position, profile, tempFields).then((_tempFields) => {
                    tempFields = _tempFields
                })

                tempFields = this.localLocalization(tempFields)

                let ggg = {};
                tempFields.forEach((value) => {
                    ggg[value[0]] = value[1];
                });

                this.fields = ggg;

                if(!this.fields['gender']) {
                    this.fields['gender'] = { value: {presentable: ''}, label: ''}
                }
                if(!this.fields['avatar_id']) {
                  this.fields['avatar_id'] = { value: {presentable: '', raw: null}, label: '' }
                }
                if(!this.fields['email']) {
                  this.fields['email'] = { value: {presentable: ''}, label: ''}
                }
                if(!this.fields['firstname']) {
                  this.fields['firstname'] = { value: {presentable: ''}, label: '' }
                }
                if(!this.fields['lastname']) {
                  this.fields['lastname'] = { value: {presentable: ''}, label: ''}
                }

                // menu objects with filter
                let menuItems = document.querySelectorAll(".menu:not(.header)");

                const objectsWithFilters = [];
                [...menuItems].map((item) => {
                    let filter = item.getAttribute('data-filter');
                    if(filter && filter.length > 0) {
                        const filterObj = [];
                        let filterArr = filter.split('|');
                        filterArr.map((filterItem) => {
                            const separatedFilterLine = filterItem.split(';');
                            if(separatedFilterLine && separatedFilterLine[0] && separatedFilterLine[1] && separatedFilterLine[2])
                                filterObj.push({
                                    name: separatedFilterLine[0],
                                    sign: separatedFilterLine[1],
                                    value: separatedFilterLine[2]
                                })
                        })
                        objectsWithFilters.push({item: item, filters: filterObj })
                    }
                });

                if(objectsWithFilters) {
                    tempFieldsAddition.map((fieldInfoObj) => {
                        objectsWithFilters.map(item => {
                            item.filters.map(filterItem => {
                                if(fieldInfoObj.alias === filterItem.name) {
                                    switch(filterItem.sign) {
                                        case '=':
                                            if(fieldInfoObj.value.presentable == filterItem.value) {
                                                item.item.classList.add('hidden');
                                            }
                                            break;
                                        case '>':
                                            if(parseInt(fieldInfoObj.value.presentable) > parseInt(filterItem.value)) {
                                                item.item.classList.add('hidden');
                                            }
                                            break;
                                        case '<':
                                            if(parseInt(fieldInfoObj.value.presentable) < parseInt(filterItem.value)) {
                                                item.item.classList.add('hidden');
                                            }
                                            break;
                                        }
                                }
                            })
                        })
                    })
                }
            }
        }
    }
</script>
<style scoped>
    @import '~bootstrap/dist/css/bootstrap.min.css';
    @import '~bootstrap/dist/css/bootstrap-grid.min.css';
    @import '~bootstrap-vue/dist/bootstrap-vue.min.css';
    @import "./../../styles/monarch/helpers/boilerplate.css";
    @import "./../../styles/monarch/themes/admin/color-schemes/default.css";
    @import "./../../styles/monarch/themes/admin/layout.css";
    @import "./../../styles/monarch/widgets/dropdown/dropdown.css";
    @import "./../../styles/monarch/helpers/utils.css";
    @import "./../../styles/monarch/themes/components/default.css";
    @import "./../../styles/monarch/elements/content-box.css";
    @import "./../../styles/monarch/elements/dashboard-box.css";
    @import "./../../styles/monarch/snippets/login-box.css";
    @import "./../../styles/monarch/helpers/spacing.css";
    @import "./../../styles/monarch/helpers/border-radius.css";
    @import "./../../styles/monarch/helpers/colors.css";
    @import "./assets/user-pop.css";
</style>
